import PropTypes from 'prop-types'
import styled from 'styled-components'
import { customPropTypes } from 'tools/react'
import { pixelise, isPercentage } from 'tools/style'
import { colors, padding, margin, borderRadius, dropShadows, dropShadowVariations, paddingSizes, marginSizes } from 'theme/default'

const Div = styled.div`
  ${props => props.width ? `width: ${pixelise(props.width)};` : ''}
  ${props => props.height ? `height: ${pixelise(props.height)};` : ''}
  ${props => props.padding ? `padding: ${padding[props.padding]};` : ''}
  ${props => props.paddingTop ? `padding-top: ${padding[props.paddingTop]};` : ''}
  ${props => props.paddingBottom ? `padding-bottom: ${padding[props.paddingBottom]};` : ''}
  ${props => props.paddingRight ? `padding-right: ${padding[props.paddingRight]};` : ''}
  ${props => props.paddingLeft ? `padding-left: ${padding[props.paddingLeft]};` : ''}
  ${props => props.margin ? `margin: ${margin[props.margin]};` : ''}
  ${props => props.marginLeft ? `margin-left: ${margin[props.marginLeft]};` : ''}
  ${props => props.marginRight ? `margin-right: ${margin[props.marginRight]};` : ''}
  ${props => props.marginTop ? `margin-top: ${margin[props.marginTop]};` : ''}
  ${props => props.marginBottom ? `margin-bottom: ${margin[props.marginBottom]};` : ''}
  ${props => props.boxShadow ? `box-shadow: ${dropShadows[props.boxShadow]};` : ''}
  ${props => props.border ? `border: 1px solid ${colors.separator};` : ''}
  ${props => props.borderTop ? `border-top: 1px solid ${colors.separator};` : ''}
  ${props => props.borderRight ? `border-right: 1px solid ${colors.separator};` : ''}
  ${props => props.borderBottom ? `border-bottom: 1px solid ${colors.separator};` : ''}
  ${props => props.borderLeft ? `border-left: 1px solid ${colors.separator};` : ''}
  ${props => props.borderRadius ? (
    isPercentage(props.borderRadius) ? `border-radius: ${props.borderRadius};` : `border-radius: ${borderRadius[props.borderRadius]};`
  ) : ''}
  ${props => props.order !== undefined ? `order: ${props.order};` : ''}
  ${props => props.flexGrow !== undefined ? `flex-grow: ${props.flexGrow};` : ''}
  ${props => props.flexShrink !== undefined ? `flex-shrink: ${props.flexShrink};` : ''}
  ${props => props.flexBasis !== undefined ? `flex-basis: ${props.flexBasis};` : ''}
  ${props => props.flex !== undefined ? `flex: ${props.flex};` : ''}
  ${props => props.alignSelf !== undefined ? `align-self: ${props.alignSelf};` : ''}
  ${props => props.opacity !== undefined ? `opacity: ${props.opacity};` : ''}
`
Div.propTypes = {
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  padding: customPropTypes.oneOfObjectKeys(paddingSizes),
  paddingTop: customPropTypes.oneOfObjectKeys(paddingSizes),
  paddingBottom: customPropTypes.oneOfObjectKeys(paddingSizes),
  paddingLeft: customPropTypes.oneOfObjectKeys(paddingSizes),
  paddingRight: customPropTypes.oneOfObjectKeys(paddingSizes),
  margin: customPropTypes.oneOfObjectKeys(marginSizes),
  marginTop: customPropTypes.oneOfObjectKeys(marginSizes),
  marginBottom: customPropTypes.oneOfObjectKeys(marginSizes),
  marginLeft: customPropTypes.oneOfObjectKeys(marginSizes),
  marginRight: customPropTypes.oneOfObjectKeys(marginSizes),
  boxShadow: customPropTypes.oneOfObjectKeys(dropShadowVariations),
  // TODO: Improve props validation for borderRadius
  borderRadius: PropTypes.string,
  order: PropTypes.number,
  flexGrow: PropTypes.number,
  flexShrink: PropTypes.number,
  flexBasis: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  flex: PropTypes.string,
  border: PropTypes.bool,
  borderTop: PropTypes.bool,
  borderRight: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderLeft: PropTypes.bool,
  alignSelf: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch'])
}

export default Div
